import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
    thumb: {
        bg: 'white',
    },
    track: {
        bg: 'gray.300',
        _checked: {
            bg: 'black',
        },
    },
});

export const switchTheme = defineMultiStyleConfig({ baseStyle });
